import {
  Component,
  Input,
  OnDestroy,
  Inject,
  ViewEncapsulation
} from '@angular/core';
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { LoadSpinnerService } from './load-spinner.service';

@Component({
  selector: 'app-spinner',
  template: `<div class="preloader overlay" *ngIf="isSpinnerVisible">
        <div class="spinner">
          <img src="assets/images/loader.gif" alt="loading..." />
          <p>Loading...</p>
      </div>
    </div>`,
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {
  public isSpinnerVisible: boolean;

  @Input() public backgroundColor = 'rgba(0, 115, 170, 0.69)';

  constructor(
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private loaderService: LoadSpinnerService
  ) {
    this.loaderService.isLoading.subscribe(v => {
      this.isSpinnerVisible = v;
    })
    this.router.events.subscribe(
      event => {
        if (event instanceof NavigationStart) {
          this.loaderService.show();
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.loaderService.hide();
        }
      },
      () => {
        this.loaderService.hide();
      }
    );
  }

  ngOnDestroy(): void {
    this.loaderService.hide();
  }
}
